import React, { MouseEventHandler } from 'react';
import classNames from 'classnames';
import { Icon } from '../icons/Icon';
import { IconNames } from '../icons/Icons';
import styles from './IconButton.module.scss';

export const IconButton = ({ onClick, icon, title, ...style }: Props) => (
    <div className={classes(style)} onClick={onClick} title={title}>
        <Icon type={icon} className={styles.icon} />
    </div>
);

const classes = ({ className, small, active }: StyleProps) => {
    return classNames(styles.default, className, {
        [styles.small]: small,
        [styles.active]: active,
        'idt-active-toggleable': active,
        'idt-inactive': !active
    });
};

type StyleProps = {
    className?: string,
    active?: boolean,
    small?: boolean,
}

type Props = StyleProps & {
    onClick: MouseEventHandler,
    icon: IconNames,
    title?: string
};
